import React from 'react';

import { Skeleton } from '@fluentui/react-components';
import { DropdownSkeletonItem, LabelSkeletonItem, RadioSkeletonItem } from '@bingads-webui-campaign-react/linkedin-shared-components';

export const LocationsSkeleton = () => (
  <Skeleton>
    <LabelSkeletonItem />
    <RadioSkeletonItem width={110} />
    <RadioSkeletonItem width={330} />
  </Skeleton>
);

export const LanguageSkeleton = () => (
  <Skeleton>
    <LabelSkeletonItem width={270} />
    <DropdownSkeletonItem />
  </Skeleton>
);

export const AudiencesSkeleton = () => (
  <Skeleton>
    <LabelSkeletonItem width={90} />
    <DropdownSkeletonItem width={320} />
    <LabelSkeletonItem width={130} />
    <DropdownSkeletonItem width={320} />
  </Skeleton>
);

export const ConversionSkeleton = () => () => (
  <Skeleton>
    <LabelSkeletonItem width={270} />
    <DropdownSkeletonItem />
  </Skeleton>
);

